import { Content } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { ContentId } from 'src/utils/constants/contentId';
import { Feature } from 'src/WebApiController';

export const CustomColumnInstruction = () => {
  const hasMinMaxInCustomColumnFeature = useUserHasFeature(
    Feature.MinMaxInCustomColumn
  );
  return (
    <Stack
      direction="column"
      gap="s"
      style={{
        padding: vars.spacing['m'],
        backgroundColor: vars.color.backgroundSecondary,
        color: vars.color.textStrong,
        borderRadius: vars.borderRadius.m,
        fontSize: vars.typography.fontSize['sm'],
        border: `1px solid ${vars.color.border} !important`,
      }}
    >
      <span>
        <Content id={ContentId.FormulaBuilderInfoLine1} />
      </span>
      <span>
        <Content id={ContentId.FormulaBuilderInfoLine2} />
      </span>
      <span>
        <Content id={ContentId.FormulaBuilderInfoLine3} />
      </span>
      <span>
        <Content id={ContentId.FormulaBuilderInfoLine4} />
      </span>
      <span>
        <Content id={ContentId.FormulaBuilderInfoLine5} />
      </span>
      <span>
        <Content id={ContentId.FormulaBuilderInfoLine6} />
      </span>
      {hasMinMaxInCustomColumnFeature && (
        <span>
          <Content id={ContentId.FormulaBuilderInfoLine7} />
        </span>
      )}
    </Stack>
  );
};
